import { Fragment } from "react";

import useGroupMemberWorkflowModal from "./UseGroupMemberWorkflowModal";

import Textarea from "@usas/ui-web/components/inputs/Textarea";
import ReadOnly from "@usas/ui-web/components/readOnly/ReadOnly";
import Dropdown from "@usas/ui-web/components/dropdowns/Dropdown";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import { SAVING_MSG } from "@usas/ui-web/utils/Constants";

import global from "@usas/ui-web/components/GlobalStyle.module.css";

const GroupMemberWorkflowModal = ({ memberObj, onCloseModal }) => {
  const {
    isSaving,
    formState,
    errorState,
    updateFormState,
    updateStepStatus,
    handleSubmit,
    statusOptions
  } = useGroupMemberWorkflowModal(memberObj, onCloseModal);

  return (
    <Fragment>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Override Group Member Status'}
        displayPopUp={isSaving !== true}
        onModalCanceled={onCloseModal}>
        <form onSubmit={handleSubmit} noValidate>
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <ReadOnly
                label='Member'
                name="groupMemberName"
                value={formState.groupMemberName} />
            </div>
            <div className="col-xs-12 col-sm-6">
              <ReadOnly
                label='Current Status'
                name="currentStatus"
                value={formState.currentStatus} />
            </div>
            <div className="col-xs-12 col-sm-6">
              <Dropdown
                label='New Status*'
                name="stepStatus"
                value={formState.stepStatus}
                error={errorState.stepStatus}
                message={errorState.stepStatus}
                options={statusOptions}
                onChange={(newValue, newValueLabel, e) => { e?.target?.value && updateStepStatus(newValue) }} />
            </div>
            {formState.displayStepNotes === true &&
              <div className="col-xs-12">
                <Textarea
                  className={global.Textarea}
                  label={`${formState.stepStatus} Notes*`}
                  name="stepNotes"
                  value={formState.stepNotes}
                  error={errorState.stepNotes}
                  message={errorState.stepNotes}
                  onChange={(value) => { updateFormState('stepNotes', value); }} />
              </div>
            }
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12 usas-extra-top-margin">
              <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
              <SecondaryButton type='button' onClick={onCloseModal}>Cancel</SecondaryButton>
            </div>
          </div>
        </form>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default GroupMemberWorkflowModal;